import axiosInstanceNew from "../lib/axiosinstanceNew";

const TransactionModal = class {
  constructor() {
    this.baseUrl = "payments";
    this.staticData = [
      {
        id: 1,
        date: "2024-11-05",
        createdAt: "2024-11-05T10:30:00Z",
        user: {
          first_name: "Rahul",
          last_name: "Sharma",
        },
        payment_for: "parentInvoice",
        pay_mode: "Upi",
        payment_type: "Credited",
        amount_paid: 15000,
      },
      {
        id: 2,
        date: "2024-11-04",
        createdAt: "2024-11-04T14:20:00Z",
        user: {
          first_name: "Priya",
          last_name: "Patel",
        },
        payment_for: "salaryDraft",
        pay_mode: "Neft/Imps",
        payment_type: "Debited",
        amount_paid: 12000,
      },
      {
        id: 3,
        date: "2024-11-03",
        createdAt: "2024-11-03T09:15:00Z",
        user: {
          first_name: "Amit",
          last_name: "Verma",
        },
        payment_for: "parentInvoice",
        pay_mode: "Cash",
        payment_type: "Credited",
        amount_paid: 22000,
      },
      {
        id: 4,
        date: "2024-11-02",
        createdAt: "2024-11-02T16:45:00Z",
        user: {
          first_name: "Sneha",
          last_name: "Gupta",
        },
        payment_for: "salaryDraft",
        pay_mode: "Upi",
        payment_type: "Debited",
        amount_paid: 18000,
      },
      {
        id: 5,
        date: "2024-11-01",
        createdAt: "2024-11-01T11:30:00Z",
        user: {
          first_name: "Vikram",
          last_name: "Singh",
        },
        payment_for: "parentInvoice",
        pay_mode: "Others",
        payment_type: "Credited",
        amount_paid: 25000,
      },
      {
        id: 6,
        date: "2024-10-30",
        createdAt: "2024-10-30T13:20:00Z",
        user: {
          first_name: "Deepak",
          last_name: "Joshi",
        },
        payment_for: "salaryDraft",
        pay_mode: "Neft/Imps",
        payment_type: "Debited",
        amount_paid: 15000,
      },
      {
        id: 7,
        date: "2024-10-29",
        createdAt: "2024-10-29T08:45:00Z",
        user: {
          first_name: "Kavita",
          last_name: "Patel",
        },
        payment_for: "parentInvoice",
        pay_mode: "Cash",
        payment_type: "Credited",
        amount_paid: 30000,
      },
      {
        id: 8,
        date: "2024-10-28",
        createdAt: "2024-10-28T15:10:00Z",
        user: {
          first_name: "Rajesh",
          last_name: "Kumar",
        },
        payment_for: "salaryDraft",
        pay_mode: "Upi",
        payment_type: "Debited",
        amount_paid: 20000,
      },
    ];
  }
  async GetAll(fromdate, todate, mode) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      let filteredData = this.staticData;

      // Filter by date range if provided
      if (fromdate && todate) {
        const startDate = new Date(fromdate);
        const endDate = new Date(todate);

        filteredData = this.staticData.filter((item) => {
          const itemDate = new Date(item.date);
          return itemDate >= startDate && itemDate <= endDate;
        });
      }

      // Filter by payment mode if provided
      if (mode) {
        filteredData = filteredData.filter((item) => item.pay_mode === mode);
      }

      return {
        data: {
          data: filteredData,
        },
      };
    } catch (error) {
      console.error("Error fetching transaction data:", error);
      throw error;
    }
  }
};
export default new TransactionModal();
